export const isDesktop = window.innerWidth > 1023;
export const isMobile = window.innerWidth < 577;



// WEBPACK FOOTER //
// ./src/utils/responsive.js